import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const whatsapp = defineConnector({
  identifier: "whatsapp",
  name: "WhatsApp",
  tagLine: "Messaging platform for business",
  keywords: "wa meta facebook cloud api graph messaging chat",
  logo,
  protocol: "http",
  tags: ["communication"],
  defaultUrlPattern: () =>
    "https://(?:graph\\.facebook\\.com/.*/messages|graph\\.facebook\\.com/.*)",
  auth: (app) => bearerAuth(app.secret.accessToken),
  steps: [
    {
      title: "Set up WhatsApp Cloud API",
      items: [
        {
          kind: "markdown",
          content:
            "Go to the [Meta Developer Portal](https://developers.facebook.com/apps/), create an app with **WhatsApp** product, and get a permanent access token from **WhatsApp → API Setup**.",
        },
        {
          kind: "input",
          label: "Phone number ID",
          required: true,
          target: { kind: "configuration", field: "phoneNumberId" },
          helperText: "Found in the WhatsApp API Setup page.",
        },
        {
          kind: "input",
          label: "Access token",
          required: true,
          target: { kind: "secrets", field: "accessToken" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ phoneNumberId }) =>
      `https://graph.facebook.com/v21.0/${phoneNumberId}`,
  },
});
